<template>
  <div id="addresses">
    <v-form ref="addressForm">
      <v-container>
        <v-layout wrap class="pr-4 pl-4">
          <v-flex xs12 class="button-container pr-0 text-xs-right">
            <v-btn fab absolute left @click="back" class="ml-3 pf-btn-fab">
              <v-icon>arrow_back</v-icon>
            </v-btn>
            <div class="d-inline-flex" v-if="selectedData">
              <v-btn class="pf-btn pf-btn-cancel" to="/configuration" @click="selectedData = false">
                <v-icon size="16" class="pr-1">cancel</v-icon>
                <div>Cancel</div>
              </v-btn>
              <v-btn class="pf-btn pf-btn-save" @click="save">
                <v-icon size="16" class="pr-1">check_circle</v-icon>
                <div>Save</div>
              </v-btn>
            </div>
          </v-flex>
        </v-layout>
        <v-layout wrap class="pb-4 pt-3">
          <v-flex class="xs12 sm6">
            <v-text-field label="Street Address Line 1" v-model.trim="newAddress.line_1" :rules="formRules.line_1" class="required pr-4 pl-4" @input="changedData"></v-text-field>
            <v-text-field label="Street Address Line 2" v-model.trim="newAddress.line_2" @input="changedData" class="pr-4 pl-4"></v-text-field>
            <v-layout wrap>
              <v-flex class="xs12 sm6 full">
                <v-text-field label="City" class="pr-4 pl-4 required" :rules="formRules.city" v-model.trim="newAddress.city" @input="changedData"></v-text-field>
              </v-flex>
              <v-flex class="xs12 sm6">
                <v-autocomplete label="Country" class="required pr-4 pl-4"
                          item-text="name"
                          item-value="id"
                          :rules="formRules.country"
                          v-model="newAddress.country"
                          :items="Country" @change="changedData"></v-autocomplete>
              </v-flex>
            </v-layout>
            <v-layout wrap>
              <v-flex class="xs12 sm6">
                <v-autocomplete label="State" item-text="name" item-value="id" :no-data-text="alertMessage" :rules="formRules.state" :items="filteredData" v-model="newAddress.state" class="required pr-4 pl-4" @change="changedData"></v-autocomplete>
              </v-flex>
              <v-flex class="xs12 sm6">
                <v-text-field label="Zip Code" v-model="newAddress.zip" :rules="formRules.zip" class="required pr-4 pl-4" @input="changedData"></v-text-field>
              </v-flex>
            </v-layout>
            <v-text-field label="Phone Number" v-mask="'(###) ###-####'" class="pr-4 pl-4" v-model="newAddress.phone" :rules="formRules.validPhone" @input="changedData"></v-text-field>
          </v-flex>
        </v-layout>
        <v-layout wrap class="pr-4 pl-4">
          <v-flex xs12 class="button-container pr-0 text-xs-right">
            <div class="d-inline-flex" v-if="selectedData">
              <v-btn class="pf-btn pf-btn-cancel" to="/configuration" @click="selectedData = false">
                <v-icon size="16" class="pr-1">cancel</v-icon>
                <div>Cancel</div>
              </v-btn>
              <v-btn class="pf-btn pf-btn-save" @click="save">
                <v-icon size="16" class="pr-1">check_circle</v-icon>
                <div>Save</div>
              </v-btn>
            </div>
          </v-flex>
        </v-layout>
      </v-container>
    </v-form>
  </div>
</template>

<script>
/* global session store */
import VeeValidate from 'vee-validate';
import Vue from 'vue';
import { getCollection, update } from '../helpers/helpers';
import swal from 'sweetalert2';
import { mapGetters } from 'vuex';
import { mask } from 'vue-the-mask';

Vue.use(VeeValidate);
export default {
  directives: { mask },
  data: () => ({
    entity: 'Agency',
    alertMessage: 'Please select country before state',
    newAddress: {
      line_1: '',
      line_2: '',
      city: '',
      state: '',
      country: '',
      zip: '',
      phone: ''
    },
    formRules: {
      line_1: [v => !!v.trim() || 'Address line 1 is required'],
      city: [v => !!v.trim() || 'City is required'],
      state: [v => !!v || 'State is required'],
      country: [v => !!v || 'Country is required'],
      zip: [v => !!v || 'Zip is required', v => /^(\d{5}|\d{6})$/.test(v) || 'Please enter valid zip code'],
      validPhone: [v => !v || /^(1\s?)?((\([0-9]{3}\))|[0-9]{3})[\s\-]?[\0-9]{3}[\s\-]?[0-9]{4}$/.test(v) || 'Please enter valid phone number']
    },
    selectedData: false,
  }),
  computed: {
    ...mapGetters(['Country', 'State']),
    filteredData () {
      if (this.newAddress.country) this.alertMessage = 'No data available';
      let options = this.State;
      return options.filter(o => o.country.id === this.newAddress.country);
    },
    Agency: {
      set (value) {
        store.commit('setAgency', value);
      },
      get () {
        return store.state.Agency;
      }
    }
  },
  created () {
    this.feedSelects('Country');
    this.initializeState();
  },
  beforeRouteEnter (to, from, next) {
    if (!session.isOnline()) {
      next({ path: '/login' });
    } else {
      next();
    }
  },
  methods: {
    changedData () {
      this.selectedData = true;
    },
    back () {
      this.$router.push({ path: '/configuration' });
    },
    hideButtons () {
      this.selectedData = false;
    },
    async feedSelects (entity) {
      if (!this[entity].length) {
        let { data, total, error } = await getCollection(entity, true);
        if (error) {
          console.log(error);
        } else {
          switch (entity) {
            case 'Country':
              store.commit('setCountry', data);
              break;
            case 'State':
              this.states = data;
              break;
            default:
              break;
          }
        }
      }
    },
    async initializeState () {
      if (!this.State.length) {
        let { error, data } = await getCollection('State', true);
        if (error) {
          console.log(error);
        } else {
          if (data.length > 0) {
            store.commit('setState', data);
          }
        }
      }
    },
    async save () {
      if (this.$refs.addressForm.validate()) {
        if (this.Agency.address) {
          this.Agency.address.push(this.newAddress);
        } else {
          this.Agency.address = [this.newAddress];
        }
        let { error, data, status } = await update(this.entity, this.Agency, session.getSession().adminUser ? session.getSession().user.human.agency : 'Me');
        if (error) {
          console.log('error', error);
        } else {
          this.Agency = Object.assign({}, data);
          this.loading = false;
          swal.fire({
            type: 'success',
            title: 'Address saved successfully',
            showConfirmButton: false,
            timer: 2500,
            onClose: () => {
              this.$router.push({ path: '/configuration' });
            }
          });
        }
      }
    }
  },

};
</script>


// WEBPACK FOOTER //
// src/pages/Address.vue